import { CallAgentScenario } from '../models';
import { ModelResource } from './resource';

export class CallAgentScenarios extends ModelResource<CallAgentScenario> {
  model = CallAgentScenario;

  resourcePath = 'v1/call-agent-scenarios';
}
